import { NotificationModel } from '@em/models/restapi/Notification.Model';
import { ChangeTrackedCollectionModel } from '@shared/models/restapi/ChangeTrackedCollection.Model';

export class NotificationCollectionModel extends ChangeTrackedCollectionModel<NotificationModel> {
    public constructor() {
        super(NotificationModel);
    }
}
